<div class="asset-review-dialog">
  <img src="assets/images/asset-review-banner.png" alt="Asset Review Banner" class="banner-image">
  <div class="button-container">
    <button mat-button class="dialog-button got-it" (click)="onClose()">Got it</button>
  </div>
</div>